import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
//import { ApplicationTypeModalComponent } from './application-type-modal/application-type-modal.component';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { ApplicationTypeModalComponent } from './application-type-modal/application-type-modal.component';
import { DeleteBoxComponent } from '../delete-box/delete-box.component';

@Component({
    selector: 'app-application-type-summary',
    standalone: false,
    templateUrl: './application-type-summary.component.html',
    styleUrl: './application-type-summary.component.scss'
})
export class ApplicationTypeSummaryComponent {

    Statuslist: any = [];
    modulelist: any[] = [];
    appTypeSearch: UntypedFormGroup;
    columnDefs: any[];
    tempoperations: any[];
    isSettings: boolean = false;
    advanceSearch;
    operations: any[];
    rowData;
    gridApi: any;
    selectedRow: any;
    ProgramList: any[];
    collapesedOrNot:boolean=false;

    constructor(
        private router: Router,
        public route: ActivatedRoute,
        private summaryService: AdministrationSummaryService,
        private modalService: NgbModal,
        private commonService: CommonService
    ) { }

    ngOnInit() {
        this.Statuslist = [
            { "value": "", "label": "All" },
            { "value": "1", "label": "Active" },
            { "value": "0", "label": "Inactive" }

        ];
        //this.getModulesList();

        this.appTypeSearch = new UntypedFormGroup({
            NAME: new UntypedFormControl(""),
            PROGRAM_ID: new UntypedFormControl(""),
            POLICY_CONFIG_ID: new UntypedFormControl(""),
            WorkflowName: new UntypedFormControl(""),
            USER_INSTRUCTIONS_ID: new UntypedFormControl(""),
            RECORD_STATE: new UntypedFormControl(),
            RecordStatus: new UntypedFormControl(""),
            COMPLIANCE_STATEMENT_ID: new UntypedFormControl(""),
            ID_CONFIGURATION_ID: new UntypedFormControl(""),
        });

        this.columnDefs = [
            {
                "headerName": "Name",
                "field": "NAME"
            },
            {
                "headerName": "Program",
                "field": "ProgramName"
            },

            {
                "headerName": "Workflow Setup",
                "field": "WorkflowName"
            },

            {
                "headerName": "Status",
                "field": "RecordStatus"
            }
        ];
        this.tempoperations = [];


        if (this.commonService.getScreenPermission("631", "V")) {
            this.isSettings = true;
            this.tempoperations.push({
                "name": "View",
                "id": "View"
            });
        }

        if (this.commonService.getScreenPermission("631", "N")) {
            this.tempoperations.push({
                "name": "Add Application Type",
                "id": "Add"
            });
        }

        if (this.commonService.getScreenPermission("631", "E")) {
            this.isSettings = true;
            this.tempoperations.push({
                "name": "Edit",
                "id": "Edit"
            });
        }

        if (this.commonService.getScreenPermission("631", "D")) {
            this.isSettings = true;
            this.tempoperations.push({
                "name": "Delete",
                "id": "Delete"
            });
        }

        this.operations = this.tempoperations.map(operation => {
            return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });

        this.summaryService.GetMasterScreenData("api/apptype/GetMasterScreenData?RecordID=").subscribe(summary => {
          this.ProgramList = summary["MasterData1"];
          this.ProgramList = [{ label: "Select", value: "", checked: true }].concat(this.ProgramList);
        });
        this.GetSummary();
    }
 onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    const ModelRef=this['self'].modalService.open(ApplicationTypeModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    ModelRef.componentInstance.Content={
      heading: 'View',
      content: { id: event.data['ID'] }
    }
  }



  Add() {
    let modalRef = this['self'].modalService.open(ApplicationTypeModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "" }
    }
    modalRef.result.then(result => {
      this['self'].GetSummary();
    })
  }


  Edit(Record:any) {
   
    let modalRef = this['self'].modalService.open(ApplicationTypeModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: { id: Record['ID'] }
    }
    modalRef.result.then(result => {
      this['self'].GetSummary();
    })
  }

  View(Record: any) {
   
     const modelRef=this['self'].modalService.open(ApplicationTypeModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modelRef.componentInstance.Content={
      heading: 'View',
      content: { id: Record['ID'] }
    }
  }



    // getModulesList() {debugger;
    //     this.summaryService.getModuleList('api/common/getmoduleslist').subscribe((result) => {
    //         this.modulelist = result;
    //     });
    // }
    GetSummary() {
        this.SearchClear();
        this.summaryService.getSummaryData('api/apptype/SummaryData').subscribe(summary => {
            this.rowData = summary;
        });
    }

    Delete(Record: any) {
      let id = Record['ID'];
      let name = Record['NAME'];
      let message = "";
      const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false});
      modalRef.componentInstance.Content={ heading: 'Delete', 
      custommessage: 'Are you sure you want to delete the Application Type   ' +"'" + name + "'" + ' ?',
       ProceedButtonName: "Delete", 
       TerminateButtonName: "Cancel" }
      modalRef.result.then(result => {
        if (result == "okclick")
          this["self"].summaryService.Delete('api/apptype/delete?id=' + id).subscribe(summary => {
            if (summary["Status"] == 0) {
              this["self"].commonService.SuccessBanner(summary.Message);
              this['self'].GetSummary();
            }
            else {
              this["self"].commonService.ValidationBanner(summary.Message);
            }
  
         });
  
      })
  
    };


    SearchClear() {
      this.appTypeSearch.patchValue({
        NAME: "",
        RecordStatus: "",
        PROGRAM_ID: "",
        WorkflowName: ""
      });

    }
    AdvanceSearch() {
      var formData = this.appTypeSearch.value;
      this.getSearchData(formData);
    }
    getSearchData(searchData) {
      this.summaryService.AdvanceSearch('api/apptype/search', searchData).subscribe(summary => {
        this.rowData = summary
      });
    }
}
